import { ControlMessage, removeSubscription, subscribeToInAppMessage } from '@braze/web-sdk';

export function addInAppMessageListener(listener: (event: { discarded: boolean }) => void) {
  const subscription = subscribeToInAppMessage(message => {
    if (!(message instanceof ControlMessage)) {
      listener({ discarded: false });
    }
  });

  return {
    remove() {
      if (subscription) {
        removeSubscription(subscription);
      }
    },
  };
}
